import {DefaultTheme, NavigationContainer, useNavigation } from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import Main from './main';
import {Loading, SignIn, PWAInstall, OfferDetails, SocialShare, SignUp, ResetPassword} from "../screens";
import React, {useEffect,useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import Constants from "expo-constants";

const Stack = createNativeStackNavigator();
const baseUrl = (Constants.experienceUrl == 'http://localhost:19006') ? 'https://shop2support.test' : Constants.experienceUrl;

const MyTheme = {
    ...DefaultTheme,
    colors: {
        ...DefaultTheme.colors,
        background: '#ffffff'
    },
};

const fetchAppDetails = async ()=>{
    const url = `${baseUrl}/wp-json/custom/v1/app_settings?cb=` + Date.now()
    try {
        return await axios.get(url);
    } catch(error) {
        if(axios.isCancel(error)){
            console.log('Data fetching cancelled for app');
            return '';
        } else {
            console.log(error)
            return '';
        }
    }

}

export default function Navigation(props) {
    const dispatch = useDispatch()
    const firstUpdate = useRef(true)
    const appVersion = '1.01'
    const currentURL = new URL(window.location.href);
    const refreshing = (currentURL.searchParams.has('refreshed') && currentURL.searchParams.get('refreshed') == 'true'); //check if refreshing so we never have an infinite loop

    useEffect(()=>{
        if (firstUpdate.current) {
            firstUpdate.current = false
            window.matchMedia('(display-mode: standalone)').addEventListener('change', (evt) => {
                if (evt.matches) {
                    console.log('refresh app')
                    window.location.reload();
                }
            });
        }
    },[props.version])

    return (
        <NavigationContainer theme={MyTheme}>
            <Stack.Navigator screenOptions={{ headerShown: false }}>
                <Stack.Screen
                    name="Loading"
                    component={Loading}
                    options={{headerShown: false}}
                    initialParams={{ appID: props.appID, themePath: props.themePath }}
                />
                <Stack.Screen
                    name="PWAInstall"
                    component={PWAInstall}
                    options={{headerShown: false, presentation: 'modal'}}
                />
                <Stack.Screen
                    name="Main"
                    component={Main}
                    options={{headerShown: false}}
                />
                <Stack.Screen
                    name="SignIn"
                    component={SignIn}
                    option={{headerShown: false}}
                />
                <Stack.Screen
                    name="SignUp"
                    component={SignUp}
                    option={{headerShown: false}}
                />
                <Stack.Screen
                    name="ResetPassword"
                    component={ResetPassword}
                    option={{headerShown: false}}
                />
                <Stack.Screen
                    name="OfferDetails"
                    component={OfferDetails}
                    option={{headerShown: false}}
                />
                <Stack.Screen
                    name="SocialShare"
                    component={SocialShare}
                    option={{headerShown: false}}
                />
            </Stack.Navigator>
        </NavigationContainer>
    );
}